import React, { FC } from 'react';
import classnames from 'classnames';

import cross from '../../assets/cross.svg';

import styles from './_RemoveButton.module.css';

interface RemoveButtonProps {
    onClick: () => void;
    ariaLabel: string;
    className?: string;
}

export const RemoveButton: FC<RemoveButtonProps> = ({ onClick, ariaLabel, className }) => (
    <button className={classnames(styles.root, className)} onClick={onClick} aria-label={ariaLabel}>
        <img className={styles.icon} src={cross} role="presentation" alt="" />
    </button>
);
